import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "contact-section bg-black",
  id: "contact"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = { class: "row gx-4 gx-lg-5" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4 mb-3 mb-md-0\"><div class=\"card py-4 h-100\"><div class=\"card-body text-center\"><i class=\"fas fa-map-marked-alt text-primary mb-2\"></i><h4 class=\"text-lowercase m-0\">address</h4><hr class=\"my-4 mx-auto\"><div class=\"small text-black-50\"> Entenmarkt 12, 53902 Bad Münstereifel, Germany </div></div></div></div>", 1)
const _hoisted_5 = { class: "col-md-4 mb-3 mb-md-0" }
const _hoisted_6 = { class: "card py-4 h-100" }
const _hoisted_7 = { class: "card-body text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope text-primary mb-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "text-lowercase em-0" }, "email", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4 mx-auto" }, null, -1)
const _hoisted_11 = { class: "small" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4 mb-3 mb-md-0\"><div class=\"card py-4 h-100\"><div class=\"card-body text-center\"><i class=\"fas fa-mobile-alt text-primary mb-2\"></i><h4 class=\"text-lowercase m-0\">phone</h4><hr class=\"my-4 mx-auto\"><div class=\"small text-black-50\">+49 2253 5448451</div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_LinkComponent, {
                  href: "mailto:info@ironwood-whistles.com",
                  "link-text": "info@ironwood-whistles.com",
                  class: "text-black-50"
                })
              ])
            ])
          ])
        ]),
        _hoisted_12
      ])
    ])
  ]))
}